import { parseJsonSafe } from './parse-json-safe';

/**
 * Pulls a human-readable message out of a failed API `Response`.
 *
 * Handles the backend's two error shapes:
 *   - Laravel-style validation: `{ errors: { field: string[] } }` → joined with `. `
 *   - Top-level: `{ message: string }`
 *
 * Falls back to `fallback` when the body is missing, not JSON, or has no usable message.
 */
export const extractErrorMessage = async (response: Response, fallback: string): Promise<string> => {
  const data = await parseJsonSafe(response);

  const errors = data?.errors;
  if (errors && typeof errors === 'object') {
    const messages = Object.values(errors)
      .flat()
      .filter((message): message is string => typeof message === 'string' && message.length > 0);
    if (messages.length) return messages.join('. ');
  }

  if (typeof data?.message === 'string' && data.message) return data.message;

  return fallback;
};
